// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3Plo1","notes":"Notes_notes__Q993S"};